// all-groups-selector.service.ts

import { Injectable } from '@angular/core';
import { expand, map, Observable, of, reduce } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IGroup } from '../typing/group.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { GroupsService } from './groups.service';
import { ICommonDropdownService } from '../ui-lib/common-dropdawn/typing/common-dropdown-service.interface';

@Injectable({
    providedIn: 'root'
})
export class AllGroupsSelectorService implements ICommonDropdownService {
    constructor(private groupsService: GroupsService) {}

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        const initialQuery = { ...query, page: 1, limit: 100 };

        return this.groupsService.getGroups(initialQuery).pipe(
            expand(response => {
                const meta = response.meta;
                const nextPage = meta && meta.currentPage < meta.totalPages ? meta.currentPage + 1 : null;
                return nextPage ? this.groupsService.getGroups({ ...initialQuery, page: nextPage }) : of();
            }),
            reduce((acc: IGroup[], response: IPaginatedResponse<IGroup>) => acc.concat(response.data), []),
            map(allGroups => {
                const transformedData = allGroups.map(group => ({
                    label: group.name,
                    value: group.id,
                    tooltip: this.getTooltip(group),
                }));

                return {
                    data: transformedData,
                    meta: {
                        totalItems: transformedData.length,
                        itemCount: transformedData.length,
                        itemsPerPage: transformedData.length,
                        totalPages: 1,
                        currentPage: 1,
                    },
                    links: {}
                };
            })
        );
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.groupsService.getGroup(Number(optionValue)).pipe(
            map(group => ({
                label: group.name as string,
                value: group.id as number,
                tooltip: '---',
            })),
        );
    }

    private getTooltip(value: IGroup): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '');
    }
}
